import React, { useEffect } from 'react';
import CustomHead from '@/components/Common/Layout/Head';
import { StoreSignupDialog, Layout } from '@/components/Common';
import { logPageView, sendEventAnalyses } from '@/lib/service';
import { ANONYMOUS_USER_ID, WEBSITE_URL } from '@/shared/constants';
import type { NextPageWithLayout } from '@/pages/_app';
import { useSearchParams } from 'next/navigation';
import { Trustpilot } from '@/components/Home';
import Image from 'next/image';
import './index.less';
import { EventName, EventSource } from '@/shared/constants/event';
import { useConfigProvider } from '@/lib/context';
import storage from '@/shared/utils/storage';
import { setAnonymousUser } from '@/shared/utils/utils';
import { useEffectOnce } from 'react-use';

const RegisterPage: NextPageWithLayout = () => {
  const { isMobile } = useConfigProvider();
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Register for Pietra',
    });
  }, []);

  useEffectOnce(() => {
    sendEventAnalyses({
      eventName: EventName.COMMON_VIEW,
      commonType: EventSource.LANDING_PAGE,
      commonContent: 'landing_page_register',
      sourceClient: isMobile ? 'mobile_web' : 'desktop_web',
      field1: 'landing_page_register_page',
      anonymousUserId: storage.get(ANONYMOUS_USER_ID) ?? setAnonymousUser(),
    });
  });

  const urlParams = useSearchParams();
  const referrer = urlParams.get('referrer');
  const email = urlParams.get('email');
  const eventSource = urlParams.get('event_source');
  const signUpRedirect = urlParams.get('signup_redirect');

  return (
    <div className="creator-registration">
      <div className="form-section">
        <StoreSignupDialog
          showCloseIcon={false}
          subtitle="Create a free account. No credit card required."
          referrer={referrer}
          email={email}
          eventSource={eventSource}
          signupRedirect={signUpRedirect}
        />
      </div>
      <div className="right-section">
        <div className="content-section">
          <Trustpilot className="register-page-rating-wrap" />
          <div className="noise"></div>
          <div className="info-wrap">
            <Image
              width={180}
              height={24}
              src="https://static.pietrastudio.com/public/file_uploads/08e73b24b9b999e8ce1618689d377776.png"
              alt="Lively Ghosts"
            />
            <div className="title">Lively Ghosts grew her brand to a 7-figure business with Pietra</div>
            <div className="description">
              &quot;Pietra is a great partner for all my brand's needs. I've leveraged their platform to source
              compelling custom products, fulfill global orders, and optimize my marketing.&quot;
              <br />- Lindsay
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
RegisterPage.getLayout = (page: React.ReactElement) => {
  const invisibleHeaderTags = (
    <div style={{ display: 'none' }}>
      <h1>Start your e-commerce business with Pietra</h1>
      <h2>Source Products</h2>
      <h2>Start Selling</h2>
      <h2>Fulfill Orders</h2>
    </div>
  );

  return (
    <>
      <CustomHead
        title="Register for Pietra"
        description="Join the community that thousands of business trust."
        url={`${WEBSITE_URL}/sell-on-pietra/register`}
      />
      <Layout hideFooter hideHeader>
        {invisibleHeaderTags}
        {page}
      </Layout>
    </>
  );
};
export default RegisterPage;
